/**
 * SplashScreenView Component
 *
 * Custom splash screen shown while fonts and resources load. Mirrors the
 * native splash from app.json: the brand mark on Bosgroen with the wordmark
 * underneath.
 */

import React from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';
import { Fonts } from '../constants/fonts';
import { Brand, Colors, Spacing } from '../constants';

// Same file as app.json's `splash.image`: the figures and arrows on transparent.
const SplashMark = require('../../assets/splash-icon.png');

interface SplashScreenViewProps {
  isReady?: boolean;
}

const MARK_SIZE = 160;

export const SplashScreenView: React.FC<SplashScreenViewProps> = () => {
  return (
    <View style={styles.container}>
      <View style={styles.logoContainer}>
        <Image source={SplashMark} style={styles.mark} resizeMode="contain" accessibilityLabel="Clubswap" />
        <Text style={styles.title}>Clubswap</Text>
        <Text style={styles.subtitle}>Voor jouw club · Door jouw club</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Brand.bosgroen,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  mark: {
    width: MARK_SIZE,
    height: MARK_SIZE,
  },
  title: {
    fontFamily: Fonts.display,
    fontSize: 40,
    lineHeight: 48,
    color: Colors.white,
    marginTop: Spacing.xl,
  },
  subtitle: {
    fontFamily: Fonts.semiBold,
    fontSize: 11,
    lineHeight: 14,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: Brand.markGold,
    marginTop: Spacing.sm,
    textAlign: 'center',
  },
});
